/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { DmvsR17PotvrdZapracovatelnostRequest } from '../types/DmvsR17PotvrdZapracovatelnost';
import type { DmvsR17PotvrdZapracovatelnostResponse } from '../types/DmvsR17PotvrdZapracovatelnost';

export type DmvsGadDocsR17PotvrdZapracovatelnostCreateRequest =
  DmvsR17PotvrdZapracovatelnostRequest;
export type DmvsGadDocsR17PotvrdZapracovatelnostCreateResponse =
  DmvsR17PotvrdZapracovatelnostResponse;

export type DmvsGadDocsR17PotvrdZapracovatelnostCreateQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this doc.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * POST /dmx-server/dmvs_gad_docs/{id}/r17_potvrd_zapracovatelnost/
 *
 * ```yaml
 * operationId: dmvs_gad_docs_r17_potvrd_zapracovatelnost_create
 * tags:
 *   - dmvs_gad_docs
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/DmvsR17PotvrdZapracovatelnost'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/DmvsR17PotvrdZapracovatelnost'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/DmvsR17PotvrdZapracovatelnost'
 *   required: true
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/DmvsR17PotvrdZapracovatelnost'
 *     description: ''
 * ```
 */
export const dmvsGadDocsR17PotvrdZapracovatelnostCreateOperation = ({
  id,
  ...rest
}: DmvsGadDocsR17PotvrdZapracovatelnostCreateQuery) =>
  ({
    method: 'POST',
    path: `/dmx-server/dmvs_gad_docs/${id}/r17_potvrd_zapracovatelnost/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'POST';
    path: string & { _templateUrl: '/dmx-server/dmvs_gad_docs/{id}/r17_potvrd_zapracovatelnost/' };
  };

/**
 * POST /dmx-server/dmvs_gad_docs/{id}/r17_potvrd_zapracovatelnost/
 *
 * ```yaml
 * operationId: dmvs_gad_docs_r17_potvrd_zapracovatelnost_create
 * tags:
 *   - dmvs_gad_docs
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/DmvsR17PotvrdZapracovatelnost'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/DmvsR17PotvrdZapracovatelnost'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/DmvsR17PotvrdZapracovatelnost'
 *   required: true
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/DmvsR17PotvrdZapracovatelnost'
 *     description: ''
 * ```
 */
export const dmvsGadDocsR17PotvrdZapracovatelnostCreate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: DmvsGadDocsR17PotvrdZapracovatelnostCreateQuery;
  request: DmvsR17PotvrdZapracovatelnostRequest;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<DmvsR17PotvrdZapracovatelnostResponse>> => {
  const operation = dmvsGadDocsR17PotvrdZapracovatelnostCreateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'POST',
    request,
    onUploadProgress,
    cancelToken,
  );
};
